<div class="face-item">
  <div class="face-thumbnail">
    <img [src]="thumbnail || '/assets/no-image.svg'" alt="Face thumbnail" />
  </div>
  <div class="face-person">
    <app-field-tags
      title="Person"
      [tags]="personValue ? [personValue] : []"
      autocompleteType="people"
      (tagsChange)="onPersonChange($event && $event.length ? $event[0] : undefined)"
      [disabled]="disabled"
      [acceptUserInput]="true"
      [oneOnly]="true"
      [noAutoPlaceholder]="true"
      theme="sidebar"
      name="person"
      (fieldFocus)="onFieldFocus()"
      (fieldBlur)="onFieldBlur()"
    ></app-field-tags>
  </div>
</div>
